// extracted by mini-css-extract-plugin
export var activeBg = "card-module--activeBg--45558";
export var bigMedia = "card-module--bigMedia--9b200";
export var body = "card-module--body--dcc77";
export var bottom = "card-module--bottom--3d991";
export var container = "card-module--container--0e692";
export var extra = "card-module--extra--7bef9";
export var lightBg = "card-module--lightBg--a1d9c";
export var lightHBg = "card-module--lightHBg--f1582";
export var main = "card-module--main--0379b";
export var media = "card-module--media--5cefa";
export var mobileCenter = "card-module--mobileCenter--12680";
export var red = "card-module--red--bd6d2";
export var square1Bg = "card-module--square1Bg--6113e";
export var squareBg = "card-module--squareBg--297e2";
export var tipColor = "card-module--tipColor--c8a65";
export var tipStyle = "card-module--tipStyle--0a7fb";
export var title = "card-module--title--6c505";
export var top = "card-module--top--62499";